<template>
  <div>
    <div class="main-wrapper">
      <!--begin::sidebar-->
      <sidebar-component classMenu="InboundDetail"></sidebar-component>
      <!--end::sidebar-->

      <div class="page-wrapper">
        <!--begin::navbar-->
        <navbar-component></navbar-component>
        <!--end::navbar-->

        <!--begin::content-->
        <div class="page-content">
          <div
            class="
              d-flex
              justify-content-between
              align-items-center
              flex-wrap
              grid-margin
            "
          >
            <div>
              <h4 class="mb-12 mb-md-0"></h4>
            </div>

            <div class="col-lg-12 col-xl-12 stretch-card">
              <div class="card">
                <div class="card-header">
                  <h4 style="margin-right: 5px" class="float-start">Inventory Detail</h4>
                 
                  <button
                    class="btn btn-danger float-end btn-xs"
                    style="margin-right: 5px"
                    @click.prevent="downloadDataPdf()"
                    :disabled="isLoading"
                  >
                     <i class="link-icon" data-feather="download"></i>
                     {{ $t("downloadData") }} .pdf
                  </button>
                  <button
                    v-if="permision_role.method_read"
                    class="btn btn-success float-end btn-xs"
                    style="margin-right: 5px"
                    @click.prevent="downloadData()"
                    :disabled="isLoading"
                  >
                     <i class="link-icon" data-feather="download"></i>
                    {{ $t("downloadData") }} .xlsx
                  </button>
                </div>

                <div class="card-body">
                  
                  <div class="card mb-3">
                    <div class="card-body">
                      <div class="row">
                        <div class="col-sm-3">
                          <div class="mb-3">
                            <label class="form-label">Fulfillment Center</label>
                             <v-select
                                :options="fetchFulfillment"
                                v-model="fulfillment"
                                v-bind:style="{padding: 0}"
                                class="form-control"
                                label="code"
                                return-object
                                @search="asyncSearchFulfillment"
                                
                              ></v-select>
                          </div>
                        </div>
                        <div class="col align-self-center" style="display:inline-block;">

                          <div class="mb-3 align-middle">
                            
                          <button class="btn btn-primary btn-sm" @click="loadItems" :disabled="isLoading">Search</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  <vue-good-table
                    title="list-user"
                    mode="remote"
                    @on-page-change="onPageChange"
                    @on-sort-change="onSortChange"
                    @on-column-filter="onColumnFilter"
                    @on-per-page-change="onPerPageChange"
                    :totalRows="totalRecords"
                    :line-numbers="true"
                    :isLoading.sync="isLoading"
                    :pagination-options="{
                      enabled: false,
                    }"
                    :sort-options="{
                      enabled: false,
                    }"
                    :rows="rows"
                    :columns="columns"
                   
                  >
                    <template slot="table-row" slot-scope="props">
                      <span v-if="props.column.field == 'actions'">
                            <a
                              href="#"
                              v-if="permision_role.method_read"
                              title="Detail"
                              @click.prevent="
                                detailData(props.index, props.row)
                              "
                            >
                              <i class="mdi mdi-eye" style="font-size:16px"></i>
                              
                            </a>
                            <a
                              href="#"
                              title="Copy"
                              @click.prevent="copyData(props.index, props.row)"
                            >
                              <i class="mdi mdi-content-copy" style="font-size: 16px"></i>
                            </a>
                            <a
                              href="#"
                              v-if="permision_role.method_update"
                              title="Edit"
                              @click.prevent="editData(props.index, props.row)"
                            >
                              <i class="mdi mdi-square-edit-outline" style="font-size:16px"></i>
                              
                            </a>

                            <a
                              href="#"
                              v-if="permision_role.method_delete"
                              title="Delete"
                              @click.prevent="
                                deleteData(props.index, props.row)
                              "
                            >
                              <i class="mdi mdi-trash-can-outline" style="font-size:16px"></i> 
                            </a>
                      </span>
                      <span v-else>
                        {{ props.formattedRow[props.column.field] }}
                      </span>
                    </template>
                  </vue-good-table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--end::content-->

        <!--begin::footer-->
        <footer-component></footer-component>
        <!--end::footer-->
      </div>
    </div>
  </div>
</template>

<script>
import sidebarComponent from "@/components/_partials/_sidebar";
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";
export default {
  name: "InventoryDetail",
  components: {
    "sidebar-component": sidebarComponent,
    "navbar-component": navbarComponent,
    "footer-component": footerComponent,
  },
  data() {
    return {
      maxToasts: 100,
      position: "up right",
      closeBtn: true,
      isLoading: false,
      errors: [],
      permision_role:[],
      langs: ["id", "en"],
      detailUser: [],
      detailDivisi: [],
      totalRecords: 0,
      serverParams: {
        columnFilters: {},
        sort: {
          field: "",
          type: "",
        },
        page: 1,
        per_page: 10,
      },
      columns: [
        
        {
          label: "WarehouseId",
          field: "warehouseid",
          
        },
        {
          label: "Customerid",
          field: "customerid",
          
        },
        {
          label: "Sku",
          field: "sku",
          
        },   
        {
          label: "Skudescr1",
          field: "skudescr1",
          
        },     
        {
          label: "lotnum",
          field: "locationid",
          
        },     
        {
          label: "Locationid",
          field: "lotnum",
          
        },     
        {
          label: "Qty",
          field: "qty",
          
        },      
        {
          label: "UOM",
          field: "uom",
          
        },  
        {
          label: "Mandate",
          field: "manDate",
          
        },  
        {
          label: "Expdate",
          field: "expDate",
          
        },   
        {
          label: "WhDate",
          field: "whDate",
          
        },    
        {
          label: "Nopen",
          field: "nOpen",
          
        },     
        
        // {
        //   label: "Action",
        //   field: "actions",
        //   sortable: false,
        // },
      ],
      rows: [],
      fulfillment:null,
      fetchFulfillment:[],
      

    };
  },
  watch: {},
  methods: {
    asyncSearchFulfillment(search){
      console.log(search);
      const baseURI = this.$settings.endPoint + "fulfillment-center/index?limit=-1&code="+search;

      return this.$http.get(baseURI).then((response) => {
        this.fetchFulfillment = response.data.datas.data;
      });
    },
    loadFulfillment(){
      const baseURI = this.$settings.endPoint + "fulfillment-center/index?limit=-1";

      return this.$http.get(baseURI).then((response) => {
        this.fetchFulfillment = response.data.datas.data;


        if(response.data.datas.total == 1){
          this.fulfillment = this.fetchFulfillment[0];
        }
      });
    },
    fetchIt() {
      const userDatas     = this.$getUserInfo();
      this.detailUser     = userDatas;
      // this.permision_role = userDatas.sub.permision_role;
      let rolePermision = [];
      userDatas.permision_role.forEach(function(permision){
        if(permision.permission.controller == 'PlbInventoryDetailViewController'){
          rolePermision = permision;
          // console.log(permision);
        }
      });

      if(!rolePermision.method_read){
        this.$router.push("/authorized-error");
      }
      this.permision_role = rolePermision;

    },

    downloadData() {
      const baseURI = this.$settings.endPoint + "plb/inventory-detail-view";
      var CurrentDate = this.$moment().format("DD_MM_YYYY_HH_mm_ss");
      var file_name = "download_" + CurrentDate + ".xlsx";

      //var columnFilters = this.serverParams.columnFilters;
      this.fade(true);
      let fulfillment = "";
      if(this.fulfillment){
        fulfillment = this.fulfillment.code; 
      }

      return this.$http
        .get(
          baseURI +
            `?fulfillment_center_code=${fulfillment}&download=excel`,
          {
            responseType: "blob",
          }
        )
        .then((response) => {
         
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");

          fileLink.href = fileURL;
          fileLink.setAttribute("download", file_name);
          document.body.appendChild(fileLink);
          fileLink.click();
          this.fade(false);
        });
    },
    downloadDataPdf() {
      const baseURI = this.$settings.endPoint + "plb/inventory-detail-view";
      var CurrentDate = this.$moment().format("DD_MM_YYYY_HH_mm_ss");
      var file_name = "download_" + CurrentDate + ".pdf";

      //var columnFilters = this.serverParams.columnFilters;
      this.fade(true);
      let fulfillment = "";
      if(this.fulfillment){
        fulfillment = this.fulfillment.code; 
      }
      return this.$http
        .get(
          baseURI +
            `?fulfillment_center_code=${fulfillment}&download=pdf`,
          {
            responseType: "blob",
          }
        )
        .then((response) => {
         
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");

          fileLink.href = fileURL;
          fileLink.setAttribute("download", file_name);
          document.body.appendChild(fileLink);
          fileLink.click();
          this.fade(false);
        });
    },

    // downloadData() {
    //   this.fade(true);
    //   var baseURI = this.$settings.endPoint + "/user/download";
    //   var CurrentDate = this.$moment().format("DD_MM_YYYY_HH_mm_ss");
    //   var columnFilters = this.serverParams.columnFilters;
    //   var role = columnFilters["role.name"];
    //   var company_code = columnFilters["company_detail.code"];

    //   var sendData = {
    //     username: this.serverParams.columnFilters.username,
    //     name: this.serverParams.columnFilters.name,
    //     email: this.serverParams.columnFilters.email,
    //     level: this.serverParams.columnFilters.level,
    //     status: this.serverParams.columnFilters.status,
    //     role:role,
    //     company_code: company_code,
    //     file_name: "download_" + CurrentDate + ".xlsx",
    //   };
    //   this.$http({
    //     url: baseURI,
    //     method: "GET",
    //     data: sendData,
    //     responseType: "blob",
    //   })
    //     .then((response) => {
    //       this.errors = [];
    //       var filename = sendData.file_name;

    //       var fileURL = window.URL.createObjectURL(new Blob([response.data]));
    //       var fileLink = document.createElement("a");

    //       fileLink.href = fileURL;
    //       fileLink.setAttribute("download", filename);
    //       document.body.appendChild(fileLink);
    //       fileLink.click();
    //       this.fade(false);
    //     })
    //     .catch((error) => {
    //       if (error.response) {
    //         if (error.response.status === 422) {
    //           this.errors = { message: ["File Not Found"] };
    //           this.error("File Not Found");
    //         } else if (error.response.status === 500) {
    //           this.$router.push("/server-error");
    //         } else {
    //           this.$router.push("/page-not-found");
    //         }
    //       }
    //     });
    // },
    createData() {
      window.location.href = "/role/add";
    },

    uploadData(){
      window.location.href = "/role/upload";
    },

    editData(index, row) {
      var params = this.$onRandom(row.role_id);
      window.location.href = "/role/edit/" + params;
    },
    copyData(index,row){
      var params = this.$onRandom(row.role_id);
      window.location.href = "/role/add/" + params;
    },
    detailData(index, row) {
      var params = this.$onRandom(row.role_id);
      window.location.href = "/role/detail/" + params;
    },

    deleteData(index, row, status) {
      this.$swal({
        title: this.$t("areYouSure"),
        text: this.$t("yourDataDelete"),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes!",
      }).then((result) => {
        if (result.value) {
          var formData = {
            status: status,
          };
          const baseURI =
            this.$settings.endPoint + "role/delete/" + row.role_id;
          this.$http
            .delete(baseURI, formData)
            .then((response) => {
              this.loading();
              if (response.data.status === 200) {
                this.success(response.data.datas.messages);
                this.loadItems();
              } else {
                this.errors = response.data.errors;
                this.resultError(response.data.errors);
              }
            })
            .catch((error) => {
              this.loading();
              if (error.response) {
                if (error.response.status === 422) {
                  this.errors = error.response.data.errors;
                  this.resultError(error.response.data.errors);
                } else if (error.response.status === 500) {
                  this.$router.push("/server-error");
                } else {
                  this.$router.push("/page-not-found");
                }
              }
            });
        }
      });
    },

    // load items is what brings back the rows from server
    loadItems() {
      this.fade(true);
      
      const baseURI = this.$settings.endPoint + "plb/inventory-detail-view";
      let fulfillment = "";
      if(this.fulfillment){
        fulfillment = this.fulfillment.code; 
      }

      return this.$http
        .get(
           baseURI+`?fulfillment_center_code=${fulfillment}&download=false`,
        )
        .then((response) => {
          this.loading();
          this.rows = response.data.datas;
          this.totalRecords = response.data.datas.length;
        }).catch((error) => {
          console.log(error);
          this.loading();
        });
    },

    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
      this.loadItems();
    },

    onColumnFilter(params) {
      params.page = 1;
      this.updateParams(params);
    },

    onPageChange(params) {
      this.updateParams({ page: params.currentPage });
    },

    onSortChange(params) {
      this.updateParams({
        sort: {
          type: params[0].type,
          field: params[0].field,
        },
      });
    },

    onPerPageChange(params) {
      this.updateParams({ per_page: params.currentPerPage });
    },

    resultError(data) {
      var count = Object.keys(data).length;
      for (var x = 0; x < count; x++) {
        var nameOb = Object.keys(data)[x];
        var objectData = data[nameOb];
        for (var y = 0; y < objectData.length; y++) {
          this.error(objectData[y]);
        }
      }
    },

    success(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "success",
        title: kata,
      });
    },

    error(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "error",
        title: kata,
      });
    },

    fade(sType) {
      this.isLoading = sType;
    },

    loading() {
      this.fade(true);
      setTimeout(() => {
        this.isLoading = false;
      }, 1000); // hide the message after 3 seconds
    },


    logout() {
      this.$logoutUser();
      this.$router.push("/");
    },
  },
  events: {},
  created: function () {},
  mounted() {
    this.fetchIt();
    this.loading();
    this.loadFulfillment();
  },
};
</script>
<style scoped>
</style>